import React from 'react'
import st from './FormField.module.scss'

export default function FormField(props) {
  return (
    <div
      className={st.formField}
      style={{ flexBasis: props.flexBasis, gap: props.gap }}
    >
      {props.children}
    </div>
  )
}
